// extracted by mini-css-extract-plugin
export default {"header_dropdown":"header_header_dropdown__HSBj3","bloodTestButton":"header_bloodTestButton__dJ1RY","menuItem":"header_menuItem__8jZeS","logo":"header_logo__w15Ng"};